import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLLinkElement> {
  scroll (): void {
    const href = this.element.getAttribute('href')
    if (href == null || href.trim() === '') return

    const id = href.replace(/^#/, '')
    if (id.trim() === '') return

    const target = document.getElementById(id)
    if (target == null) return

    let secondParent = target.parentElement?.parentElement ?? null
    if (secondParent == null) {
      secondParent = target
    }

    const header = document.getElementById('header')
    const headerHeight = header?.offsetHeight ?? 0
    const elementPosition = secondParent.getBoundingClientRect().top + window.scrollY

    if (headerHeight !== 0) {
      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: 'smooth'
      })
    } else {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
